export default {
    setBusinessUnit: (state, value) => state.businessUnit = value,
    setFleetSize: (state, fleetSize) => state.fleetSize = fleetSize,
    setInquiryModalSubmitted: (state, value) => state.inquiryModalSubmitted = value
}